import { Button } from "@components/buttons/button";
import { useAuthContext } from "@hooks/contexts/auth-context";
import { IClientAuthDTO } from "@hooks/dtos/IClientDTO";
import { abbreviateName, formatName } from "@hooks/functions/formatName";
import { ModalType, useModalStore } from "@hooks/stores/zustand-modal-store";
import { ZuToastifyStore } from "@hooks/stores/zustand-toastify-store";
import { defaultAvatar } from "index";
import { useEffect, useRef, useState } from "react";
import { FaPersonBooth, FaRegUser, FaSignOutAlt } from "react-icons/fa";

interface IProps {
  client: IClientAuthDTO;
}

export const VerifiedPanel = ({ client }: IProps) => {
  const { signOut } = useAuthContext();
  const menuRef = useRef<HTMLDivElement>(null);
  const {
    actions: { pushToastify },
  } = ZuToastifyStore();

  const openModal = useModalStore((state) => state.openModal);
  const [showClientMenu, setShowClientMenu] = useState<boolean>(false);

  useEffect(() => {
    if (!showClientMenu) return;

    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setShowClientMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showClientMenu]);

  return (
    <>
      <div className="flex-fill position-relative" ref={menuRef}>
        <div
          className="d-flex align-items-center"
          style={{
            background: "#f8f9fa",
            borderRadius: "1rem",
            cursor: "pointer",
            border: "0.12rem solid #dee2e6",
            paddingInline: "1rem",
            minHeight: "56px",
          }}
          onClick={() => setShowClientMenu((prev) => !prev)}
        >
          <div
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              overflow: "hidden",
              flexShrink: 0,
              marginRight: "8px",
            }}
          >
            <img
              src={defaultAvatar}
              alt="User"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </div>

          <div className="flex-grow-1 overflow-hidden" style={{ minWidth: 0 }}>
            <div className="d-flex align-items-center">
              <div
                className="fw-bold text-truncate"
                style={{ fontSize: "14px" }}
              >
                {abbreviateName(
                  formatName(client.client.name ?? "Sem Nome"),
                  15,
                )}
              </div>
            </div>

            <div className="d-flex align-items-center">
              <div
                className="rounded-circle bg-success me-2"
                style={{
                  width: "12px",
                  height: "12px",
                }}
              />
              <span>{"Autenticado"}</span>
            </div>
          </div>
        </div>

        {showClientMenu && (
          <div
            className="position-absolute w-100"
            style={{
              top: "100%",
              left: 0,
              background: "white",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              zIndex: 1000,
              marginTop: "4px",
            }}
          >
            <div className="p-2">
              <button
                className="btn btn-outline-success w-100 mb-2 d-flex align-items-center justify-content-center gap-2"
                onClick={() => {
                  pushToastify({
                    message: "Em construção...",
                    type: "info",
                    theme: "dark",
                  });
                }}
              >
                <FaPersonBooth className="fs-6" />
                Meu Perfil
              </button>
              <button
                className="btn btn-outline-primary w-100 mb-2 d-flex align-items-center justify-content-center gap-2"
                onClick={() =>
                  openModal(ModalType.MANAGEMENT_VERIFIED, {
                    primaryInfo: true,
                  })
                }
              >
                <FaRegUser className="fs-6" />
                Meus Dados
              </button>
              <button
                className="btn btn-outline-danger w-100 d-flex align-items-center justify-content-center gap-2"
                onClick={() => {
                  signOut();
                  setShowClientMenu(false);
                }}
              >
                <FaSignOutAlt className="fs-6" />
                Sair
              </button>
            </div>
          </div>
        )}
      </div>
      {/* <Button className="btn btn-success rounded-3">Meu Perfil</Button> */}
    </>
  );
};
